import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { SUFIJO } from '../../components/common/PageTitle';

// «No encontramos esta página»: las direcciones que no existen (la ruta «*» de App.js) y el enlace a un servicio que no existe.
// Trae un buscador (como el del encabezado, va a /buscar) y un botón al inicio.
const NoEncontrado = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [buscar, setBuscar] = useState('');

  // PageTitle no conoce esta pantalla: el título se pone aquí (este efecto corre después del suyo)
  useEffect(() => {
    document.title = `Página no encontrada | ${SUFIJO}`;
  }, [pathname]);

  const submitSearch = (e) => {
    e.preventDefault();
    const q = buscar.trim();
    navigate(q ? `/buscar?q=${encodeURIComponent(q)}` : '/buscar');
  };

  return (
    <Box className="main-page">
      <Box sx={{ bgcolor: 'secondary.main', color: 'primary.main', borderRadius: 2, px: 4, py: 5, mb: 3 }}>
        <Typography variant="h5">No encontramos esta página</Typography>
        <Typography mt={2} variant="body1" color="primary">
          <small>La dirección no existe o lo que buscabas ya no está aquí. Busca un servicio o vuelve al inicio.</small>
        </Typography>
      </Box>

      <Box component="form" role="search" onSubmit={submitSearch} sx={{ display: 'flex', gap: 1, maxWidth: 560, mb: 3 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="¿Qué servicio estás buscando?"
          value={buscar}
          onChange={(e) => setBuscar(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="primary" />
                </InputAdornment>
              ),
            },
            htmlInput: { 'aria-label': 'Buscar servicios' },
          }}
        />
        <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>
          Buscar
        </Button>
      </Box>

      <Button variant="outlined" onClick={() => navigate('/')} sx={{ textTransform: 'none' }}>
        Ir al inicio
      </Button>
    </Box>
  );
};

export default NoEncontrado;
